export const darkTheme = {
    bg: "#080b14",
    bgLight: "#0d1120",
    primary: "#7c6af7",
    primary_light: "rgba(124, 106, 247, 0.12)",
    primary_glow: "rgba(124, 106, 247, 0.35)",
    text_primary: "#eef0f4",
    text_secondary: "#8b93a8",
    text_tertiary: "#5c6478",
    card: "#0f1525",
    card_solid: "#0f1525",
    card_light: "#111827",
    card_border: "rgba(124, 106, 247, 0.12)",
    button: "#7c6af7",
    white: "#FFFFFF",
    black: "#000000",
    gradient_primary: "linear-gradient(135deg, #6366f1 0%, #7c6af7 50%, #854CE6 100%)",
    gradient_text: "linear-gradient(135deg, #6366f1 0%, #7c6af7 60%, #a78bfa 100%)",
    gradient_bg: "linear-gradient(180deg, #080b14 0%, #0d1120 100%)",
    shadow: "rgba(0, 0, 0, 0.4)",
    shadow_primary: "rgba(124, 106, 247, 0.18)",
    glass: "rgba(8, 11, 20, 0.85)",
    glass_border: "rgba(255, 255, 255, 0.04)",
    divider: "rgba(255, 255, 255, 0.07)",
};

export const lightTheme = {
    bg: "#FFFFFF",
    bgLight: "#f5f5ff",
    primary: "#6366f1",
    primary_light: "rgba(99, 102, 241, 0.1)",
    primary_glow: "rgba(99, 102, 241, 0.2)",
    text_primary: "#0f172a",
    text_secondary: "#475569",
    text_tertiary: "#94a3b8",
    card: "rgba(255, 255, 255, 0.9)",
    card_solid: "#FFFFFF",
    card_light: "rgba(245, 245, 255, 0.9)",
    card_border: "rgba(99, 102, 241, 0.1)",
    button: "#6366f1",
    white: "#FFFFFF",
    black: "#000000",
    gradient_primary: "linear-gradient(135deg, #6366f1 0%, #7c6af7 50%, #854CE6 100%)",
    gradient_text: "linear-gradient(135deg, #6366f1 0%, #7c6af7 60%, #a78bfa 100%)",
    gradient_bg: "linear-gradient(180deg, #FFFFFF 0%, #f5f5ff 100%)",
    shadow: "rgba(0, 0, 0, 0.08)",
    shadow_primary: "rgba(99, 102, 241, 0.12)",
    glass: "rgba(255, 255, 255, 0.8)",
    glass_border: "rgba(0, 0, 0, 0.05)",
    divider: "rgba(0, 0, 0, 0.07)",
};
